import { useNavigate } from "react-router-dom";
import { departments } from "./data";

import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useState } from "react";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import CostingDetails from "./Departments/CostingDetails/CostingDetails";

const SelectedShootCosting = () => {
	const [activeDepartment, setActiveDepartment] = useState(departments.COSTING_DETAILS.key);
	const [selectedCostingDetails, setSelectedCostingDetails] = useState({});
	const handleDepartmentChange = (e, val) => {
		setActiveDepartment(val);
	};
	const tabComponents = [
		{
			...departments.COSTING_DETAILS,
			component: <CostingDetails selectedCosting={selectedCostingDetails} setSelectedCosting={setSelectedCostingDetails} />,
		},
	];
	let scroll = 600;
	const handleScroll = () => {
		if (scroll > 2300) scroll = 0;
		window.scrollTo({ top: scroll, behavior: "smooth" });
		scroll += 600;
	};
	return (
		<Box sx={{ width: "100%", p: 1 }} position="relative">
			<Tabs value={activeDepartment} onChange={handleDepartmentChange}>
				{Object.keys(departments).map((row) => {
					return <Tab label={departments[row].name} value={departments[row].key} />;
				})}
			</Tabs>

			{tabComponents?.map((row) => (
				<Box width="100%" margin="auto" key={row.key} display={row.key === activeDepartment ? "block" : "none"}>
					{row.component}
				</Box>
			))}
			<Fab
				size="small"
				color="primary"
				aria-label="add"
				sx={{ position: "fixed", right: "5%", bottom: "5%" }}
				onClick={handleScroll}>
				<KeyboardArrowDown />
			</Fab>
		</Box>
	);
};

export default SelectedShootCosting;
